import {Component} from "react";
import React from "react";
import { Route, NavLink, Switch } from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';
import close from "../close2.svg";
import Scrollbar from 'react-scrollbars-custom';
import { DOMAIN_NAME } from '../Const';
import { CUR_LANG } from '../Const';
import MainSlider from "./MainSlider";

let lang = CUR_LANG;

function NoMatch({ location }) {
    return (
        <div>
            <h3>
                No match for <code>{location.pathname}</code>
            </h3>
        </div>
    );
}

function AsideData({ match }) {
    let articleData;
    let currentUrl = match.params.data;
    fetch(DOMAIN_NAME+'/'+lang+'/section/get')
        .then(
            function (response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' + response.status);
                    return;
                }
                response.json().then(function(data) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].button == currentUrl){
                            articleData = data[i];
                            if (articleData) {
                                document.querySelector(".ScrollbarsCustom-content").innerHTML  = articleData.text;
                            } else {
                                console.log('нету');
                            }


                        }
                    }
                    return;
                });
            }
        )
        .catch(function(err) {
            console.log('Fetch Error :-S', err);
        });
    return (
        <div>{articleData}</div>
    );
}
class Detail extends Component {
    render() {
        let asideMenu=[];
        if (CUR_LANG ==="ru"){
            asideMenu=[
                'О нас',
                'Наши достижения',
                'Продукты',
                'Высококремнистые литейные алюминиевые сплавы',
                'Алюминиевый переплав в виде чушек и слябов',
                'Медный переплав',
                'Латунный переплав',
                'Сфера применения',
                'Логистика',
                'Карьера',
                'Контакты',
                'Отказ от ответственности',
                'Условия использования'
            ];
        } else {
            asideMenu=[
                'About',
                'Our achievements',
                'Products',
                'High Silicon Foundry Aluminum Alloys',
                'Aluminum remelting in the form of ingots and slabs',
                'Copper remelting',
                'Brass remelting',
                'Scope of application',
                'Logistics',
                'Career',
                'Contacts',
                'Denial of responsibility',
                'Terms of Use'
            ];
        }
        var ferma;
        if (CUR_LANG ==="ru"){
            ferma='создание сайта';
        } else {
            ferma='site creation';
        }
        return (
            <div className="slides-more-info">
                <div className="slides-more-info--wrapper">
                    <div className="slides-more-info-left">
                        <ul className="slides-more-info-left--menuList">
                            <li>
                                <NavLink activeClassName="active-link" to="/about">{asideMenu[0]}</NavLink>
                            </li>
                            <li>
                                <NavLink activeClassName="active-link" to="/nashi-dostizheniya">{asideMenu[1]}</NavLink>
                            </li>
                            <li className = "products-link">
                                <NavLink activeClassName="active-link" to="/produkty">{asideMenu[2]}</NavLink>
                                <ul>
                                    <li>
                                        <Link to="/produkty#vysokokremnistye-litejnye-alyuminievye-splavy">
                                            {asideMenu[3]}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/produkty#alyuminievyj-pereplav-v-vide-chushek-i-slyabov">
                                            {asideMenu[4]}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/produkty#mednyj-pereplav">
                                            {asideMenu[5]}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/produkty#latunnyj-pereplav">
                                            {asideMenu[6]}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li><NavLink activeClassName="active-link" to="/sfera-primeneniya">{asideMenu[7]}</NavLink></li>
                            <li><NavLink activeClassName="active-link" to="/logistika">{asideMenu[8]}</NavLink></li>
                            <li><NavLink activeClassName="active-link" to="/karera">{asideMenu[9]}</NavLink></li>
                            <li><NavLink activeClassName="active-link" to="/kontakty">{asideMenu[10]}</NavLink></li>
                        </ul>
                        <ul className="slides-more-info-left--secondMenu">
                            <li><NavLink activeClassName="active-link" to="/otkaz-ot-otvetstvennosti">{asideMenu[11]}</NavLink></li>
                            <li><NavLink activeClassName="active-link" to="/usloviya-ispolzovaniya">{asideMenu[12]}</NavLink></li>
                        </ul>
                        <a href="http://fermastudio.com" target="_blank" className="developer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="126" height="46" viewBox="0 0 126 46" fill="none">
                                <path d="M125.262 35.5797C124.52 35.5797 123.566 36.1609 123.142 36.2137C122.347 36.3194 121.234 36.0024 120.651 31.4587C120.332 28.7642 120.651 25.9641 120.757 23.2695C120.81 22.5299 113.601 23.6394 113.495 25.7527C113.336 29.0812 112.859 32.5682 113.707 35.8439C113.707 35.9496 113.76 36.0024 113.813 36.1081C110.368 37.0062 106.816 35.1571 105.597 31.5116C105.279 30.5077 105.12 29.3454 105.12 28.1831C105.173 27.8661 105.279 25.6471 105.385 24.9074C110.209 23.9035 114.926 22.3185 119.219 20.0467C119.696 19.8354 120.81 19.2542 120.704 18.5674C119.431 8.74036 109.572 10.5367 102.788 13.7067C101.039 14.552 100.509 15.0275 100.668 16.1899C100.774 17.1937 101.887 17.5107 102.841 17.2465C103.954 16.9295 104.643 15.6615 105.968 15.0275C110.474 12.9142 112.594 16.3484 113.389 20.3637C110.58 21.5789 102.841 22.9525 100.138 23.3752C99.0245 23.5337 98.7065 24.379 98.5474 25.1187C98.1764 26.7037 97.9644 28.3944 97.9114 29.9794C97.8054 31.8814 97.5404 35.6854 95.8442 36.0024C94.148 36.3194 94.4131 28.7114 94.4661 27.1264C94.5191 23.4809 94.8901 19.8882 94.095 16.2955C92.8229 10.5367 86.1973 11.3292 81.3738 13.4425C78.7766 10.5895 73.7941 11.0122 69.3417 12.333C68.2286 12.65 65.2073 13.3897 65.1013 14.869C64.2002 23.745 63.5112 33.3079 64.9953 42.2896C59.3768 40.2291 54.6063 34.3117 53.3342 28.4472C58.2637 27.7604 62.5041 25.8584 61.868 19.941C60.8079 9.7442 49.9949 8.84603 40.295 13.1255C39.2349 13.601 38.9699 14.235 38.5458 15.7672C37.1677 20.8392 36.1606 30.5077 37.5917 38.3799C37.6977 39.0139 39.1819 39.7007 41.5671 39.7007C43.9523 39.7007 45.5425 39.1724 45.3305 38.3271C42.9452 28.8171 44.2704 18.0919 45.5425 14.0765C55.6664 13.1784 54.9774 23.745 54.8183 25.2244C54.6593 26.7566 52.6451 26.9679 52.0621 25.3829C51.479 23.9035 45.5955 25.0659 45.7015 28.1302C46.0195 39.3837 56.9385 47.4672 67.6986 45.7766C68.5466 45.6709 73.2111 44.5086 72.893 43.0821C70.8258 33.9947 71.0379 24.2205 71.8859 14.9747C79.2006 11.7519 75.8083 32.9909 75.7023 38.4327C75.7023 38.8026 76.7094 39.3837 79.4127 39.3837C81.7979 39.3837 82.911 39.1724 82.964 38.1686C83.07 33.5721 83.229 27.9717 83.229 22.8997C83.229 21.4204 83.282 17.3522 82.4869 15.6615C88.2645 12.8614 87.6814 23.6922 87.6284 25.7527C87.5754 29.5039 86.5683 35.5269 89.5366 38.4856C91.9218 40.8102 97.2223 39.4894 100.138 36.8477C100.774 37.5346 101.516 38.1686 102.47 38.6969C106.021 40.6517 110.898 39.7007 115.032 38.0629C116.728 39.4894 119.643 39.2781 121.976 38.7497C123.195 38.4856 125.262 37.7987 125.898 36.5836C126.163 36.0552 125.898 35.5269 125.262 35.5797Z" fill="#5A88FF"/>
                                <path d="M34.6764 33.9951C34.5174 32.9385 33.0333 32.9385 32.1852 33.097C30.5951 33.3611 30.012 35.2103 27.8918 36.1085C26.6727 36.6368 25.0295 36.7953 23.9164 36.4255C20.8952 35.3688 20.1531 32.8328 19.729 29.9798C19.093 25.8588 19.358 20.6811 20.7891 16.6129C21.1602 15.5563 15.2766 14.2354 14.0045 17.5111C11.5663 23.6398 10.6122 33.414 16.0717 38.0633C20.4711 41.8145 27.3088 39.5955 32.2382 36.584C33.0333 36.0028 34.7825 34.7348 34.6764 33.9951Z" fill="#5A88FF"/>
                                <path d="M6.68989 10.642C9.44615 9.84949 9.76418 9.37399 9.76418 8.58148C9.76418 6.57382 9.9762 4.61898 11.0893 3.08681C12.4674 3.03398 14.4286 3.45665 16.0718 3.82648C17.9269 4.19631 19.1461 3.66798 20.4182 3.08681C20.5242 3.03398 23.4395 1.29048 22.2203 0.973475C13.7926 -1.50969 2.87354 0.445141 2.87354 10.4835C2.87354 11.276 3.88063 11.4345 6.68989 10.642Z" fill="#5A88FF"/>
                                <path d="M9.92311 14.3391C16.7078 12.7541 24.7645 11.8031 27.5738 18.7771C28.1038 20.1508 28.3158 21.6301 28.3158 23.1095C28.3158 24.3775 27.9978 25.4341 26.0366 25.1171C25.1885 24.9586 23.1214 23.9548 21.9552 24.6945C20.7361 25.4341 21.0012 28.1286 22.2203 28.023C26.1426 27.8116 34.9945 26.755 35.5245 21.4716C35.8955 18.0903 35.3125 15.1316 32.0792 12.5956C26.3016 7.94629 10.5062 11.2748 1.1773 14.2863C0.170201 14.6033 -0.359849 15.8185 0.276211 16.3996C0.91227 16.9808 2.66143 16.294 2.66143 16.4525C1.81335 21.8415 1.76035 33.8875 2.39641 39.752C2.44941 40.2803 3.24449 40.4917 5.57671 40.4917C7.90893 40.4917 9.60508 39.9633 9.55208 39.0123C9.18105 31.5628 8.49198 22 9.92311 14.3391Z" fill="#5A88FF"/>
                            </svg>
                            <span className="developer--text">{ferma}</span>
                        </a>
                    </div>
                    <div className="slides-more-info-right">
                        <Scrollbar style={ {width: '100%', height: '100%', minHeight: 300} } >
                            <Switch>
                                <Route exact path="/" component={AsideData} />
                                <Route path="/:data" component={AsideData} />
                                <Route path="" component={NoMatch} />
                            </Switch>
                        </Scrollbar>
                    </div>
                    <NavLink to="/" className="close-slide close-slider--js">
                        <img src={close} alt="Логотип" />
                    </NavLink>
                </div>
            </div>
        );
    }
}

export default Detail;
